import React from "react"
import { useParams } from "react-router-dom"
import {
    GotvCampaignFooter,
    DEFAULT_SOCIAL_HEADER,
} from "QuorumGrassroots/widgets/GotvCampaignFooter/GotvCampaignFooter"
import { useGotvSocialSharing } from "QuorumGrassroots/widgets/GotvCampaignFooter/useGotvSocialSharing"
import { CampaignSubpageHeader } from "QuorumGrassroots/widgets/ReusableComponents/CampaignSubpageHeader"
import {
    SubpageContainer,
    NextElectionBannerWrapper,
    PlaceholderSection,
} from "QuorumGrassroots/pages/campaign/key-dates/styles"
import { NextElectionInfo } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/NextElectionInfo/NextElectionInfo"
import { useCampaign } from "QuorumGrassroots/services/grassrootsCampaign"
import { CampaignTitleSubtitle } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CampaignTitleSubtitle/CampaignTitleSubtitle"

export const KeyDatesPage: React.FC = () => {
    const { id } = useParams<{ id: string }>()

    const { data: campaign, isLoading, isError } = useCampaign(id)

    const socialPlatforms = useGotvSocialSharing({
        socialMediaPlatforms: campaign?.social_media_platforms,
        shareUrl: window.location.href,
        shareText: campaign?.social_share_text ?? `Help ${campaign?.name} get out the vote!`,
        imageUrl: campaign?.social_image_url,
    })

    if (isLoading) return <div>Loading...</div>
    if (isError || !campaign) return <div>Error loading campaign</div>

    return (
        <SubpageContainer>
            <CampaignTitleSubtitle campaign={campaign} />
            <CampaignSubpageHeader title="Check Key Dates" backUrl={`/campaign/${id}`} dataCy="key-dates-header" />

            {/* Next Election banner per design (mocked, UI-only) */}
            <NextElectionBannerWrapper>
                <NextElectionInfo electionName="New York General Election" electionDate="Nov 5, 2024" />
            </NextElectionBannerWrapper>

            {/* TODO: Add actual key dates content here */}
            <PlaceholderSection>
                <p>Key dates and timeline will be displayed here...</p>
            </PlaceholderSection>

            <GotvCampaignFooter
                socialPlatforms={socialPlatforms}
                socialHeading={campaign.social_header ?? DEFAULT_SOCIAL_HEADER}
            />
        </SubpageContainer>
    )
}
